
:host {
    display: block;

    .isLoading::after {
      content: '';
      position: fixed;
      top:0;
      left:0;
      right: 0;
      bottom: 0;

      width: 100%;
      height: 100%;
      z-index: 150;
      background-color: rgba(255, 255, 255, .25);
      backdrop-filter: blur(5px);
    }
}

// storybook-spinner - START
.spinner {
  border-radius: 50%;
  cursor: progress;
  display: inline-block;
  overflow: hidden;
  position: absolute;
  -webkit-transition: all 200ms ease-out;
  transition: all 200ms ease-out;
  vertical-align: top;
  top: 50%;
  left: 50%;
  margin-top: -16px;
  margin-left: -16px;
  height: 100px;
  width: 100px;
  z-index: 200;
  border-width: 2px;
  border-style: solid;
  border-color: rgba(97, 97, 97, 0.29);
  border-top-color: rgb(100, 100, 100);
  -webkit-animation: spinner-animation 0.7s linear infinite;
  animation: spinner-animation 0.7s linear infinite;
  mix-blend-mode: difference;
}

@keyframes spinner-animation {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
// storybook-spinner - END


.hasError {
  position: absolute;
  z-index: 9999;
  height: 200px;
  width: 30vw;
  top: calc(50% - 100px);
  left: calc(50% - 15vw);
  background-color: lightgray;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px;
}
